import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const TrainingLoadStatusChip = ({ status }) => {
  const statusConfig = {
    severely_undertrained: { color: 'error', label: 'Severely Undertrained', icon: <TrendingDownIcon /> },
    undertrained: { color: 'warning', label: 'Undertrained', icon: <TrendingDownIcon /> },
    slightly_undertrained: { color: 'info', label: 'Slightly Undertrained', icon: <TrendingDownIcon /> },
    optimal: { color: 'success', label: 'Optimal', icon: <CheckCircleIcon /> },
    slightly_overtrained: { color: 'info', label: 'Slightly Overtrained', icon: <TrendingUpIcon /> },
    overtrained: { color: 'warning', label: 'Overtrained', icon: <WarningAmberIcon /> },
    severely_overtrained: { color: 'error', label: 'Severely Overtrained', icon: <ErrorOutlineIcon /> },
  };
  const config = statusConfig[status] || statusConfig.optimal;
  return (
    <Chip icon={config.icon} label={config.label} color={config.color} size="small" sx={{ fontWeight: 600 }} />
  );
};

TrainingLoadStatusChip.propTypes = { status: PropTypes.string };

export default TrainingLoadStatusChip;